import { React, useState } from 'react';
import Modal2Booked from './Modal2Booked';
import { FaEdit, FaEye } from "react-icons/fa";

function Booked({ consultations = [], fetchConsultations }) {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingConsultation, setEditingConsultation] = useState(null);

  // Helper to format date as dd-mm-yy
  const formatDate = (isoString) => {
    if (!isoString) return ""; // or "N/A"
    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return "";

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear().toString().slice(-2);
    return `${day}/${month}/${year}`;
  };

  // Helper to format time in AM/PM
  const formatTime = (time) => {
    if (!time) return ""; // or "N/A"
    const [hours, minutes] = time.split(":");
    const parsedHours = parseInt(hours, 10);
    const ampm = parsedHours >= 12 ? "PM" : "AM";
    const formattedHours = parsedHours % 12 || 12; // Convert to 12-hour format
    return `${formattedHours}:${minutes} ${ampm}`;
  };

  // Filter consultations where isConducted is false
  const pendingConsultations = consultations.filter(consultation => !consultation.isConducted);
  const conductedConsultations = consultations.filter(consultation => consultation.isConducted);

  const openEditModal = (consultation) => {
    setEditingConsultation(consultation);
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setEditingConsultation(null);
  };

  return (
    <div className="px-10 py-6 bg-white rounded">
      <h3 className="text-lg font-medium mb-4 text-gray-700">Booked Consultations</h3>
      <table className="w-full table-auto border-t border-b border-gray-300">
        <thead>
          <tr className="border-b border-gray-300">
            <th className="px-4 py-2 text-center text-gray-400">Consultation ID</th>
            <th className="px-4 py-2 text-center text-gray-400">Name</th>
            <th className="px-4 py-2 text-center text-gray-400">Email</th>
            <th className="px-4 py-2 text-center text-gray-400">Date</th>
            <th className="px-4 py-2 text-center text-gray-400">Time</th>
            <th className="px-4 py-2 text-center text-gray-400">Link</th>
            <th className="px-4 py-2 text-center text-gray-400">Action</th>
          </tr>
        </thead>
        <tbody>
          {pendingConsultations.length > 0 ? (
            pendingConsultations.map((consultation) => (
              <tr
                key={consultation.consultationId}
                className="border-b border-gray-300 text-center"
              >
                <td className="px-4 py-4 text-sm text-gray-700">{consultation.consultationId}</td>
                <td className="px-4 py-4 text-sm text-gray-700">{consultation.studentName}</td>
                <td className="px-4 py-4 text-sm text-gray-700">{consultation.email}</td>
                <td className="px-4 py-4 text-sm text-gray-700">{formatDate(consultation.consultationDate)}</td>
                <td className="px-4 py-4 text-sm text-gray-700">{formatTime(consultation.consultationTime)}</td>
                <td className="px-4 py-4 text-sm text-gray-700">
                  {consultation.meetingLink ? (
                    <a
                      className="text-blue-500"
                      title="Join meeting"
                      href={consultation.meetingLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      join
                    </a>
                  ) : (
                    "N/A"
                  )}
                </td>
                <td className="px-4 py-4 text-sm text-gray-700">
                  <div className="flex items-center justify-center">
                    <FaEdit
                      className="text-blue-500 hover:text-blue-600 cursor-pointer w-5 h-5"
                      onClick={() => openEditModal(consultation)}
                    />
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="px-4 py-4 text-sm text-gray-700 text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <h3 className="text-lg font-medium my-4 text-gray-700">Conducted Consultations</h3>
      <table className="w-full table-auto border-t border-b border-gray-300">
        <thead>
          <tr className="border-b border-gray-300">
            <th className="px-4 py-2 text-center text-gray-400">Consultation ID</th>
            <th className="px-4 py-2 text-center text-gray-400">Name</th>
            <th className="px-4 py-2 text-center text-gray-400">Email</th>
            <th className="px-4 py-2 text-center text-gray-400">Date</th>
            <th className="px-4 py-2 text-center text-gray-400">Time</th>
            <th className="px-4 py-2 text-center text-gray-400">Action</th>
          </tr>
        </thead>
        <tbody>
          {conductedConsultations.length > 0 ? (
            conductedConsultations.map((consultation) => (
              <tr
                key={consultation.consultationId}
                className="border-b border-gray-300 text-center"
              >
                <td className="px-4 py-4 text-sm text-gray-700">{consultation.consultationId}</td>
                <td className="px-4 py-4 text-sm text-gray-700">{consultation.studentName}</td>
                <td className="px-4 py-4 text-sm text-gray-700">{consultation.email}</td>
                <td className="px-4 py-4 text-sm text-gray-700">{formatDate(consultation.consultationDate)}</td>
                <td className="px-4 py-4 text-sm text-gray-700">{formatTime(consultation.consultationTime)}</td>
                
                <td className="px-4 py-4 text-sm text-gray-700">
                  <div className="flex items-center justify-center">
                    <FaEye
                      className="text-blue-500 hover:text-blue-600 cursor-pointer w-5 h-5"
                      onClick={() => openEditModal(consultation)}
                    />
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="px-4 py-4 text-sm text-gray-700 text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {isEditModalOpen && (
        <Modal2Booked
          isOpen={isEditModalOpen}
          onClose={closeEditModal}
          consultation={editingConsultation}
          fetchConsultations={fetchConsultations}
        />
      )}
    </div>
  );
}

export default Booked;